import React from 'react'
import { DeviceTypeEnum } from '../../../data/enums'
import { DisplayBasicConfig } from './BasicConfigTypes/DisplayBasicConfig'
import { ScannerBasicConfig } from './BasicConfigTypes/ScannerBasicConfig'
import { TerminalBasicConfig } from './BasicConfigTypes/TerminalBasicConfig'

export const BasicConfig = (props) => {
    switch (props.deviceType) {
        case DeviceTypeEnum.SCANNER:
            return <ScannerBasicConfig {...props} />
        case DeviceTypeEnum.TERMINAL:
            return <TerminalBasicConfig {...props} />
        case DeviceTypeEnum.DISPLAY:
            return <DisplayBasicConfig {...props} />
        default:
            if (!props.selectedDevice) {
                return null
            }
            return <> Not supported. Comming soon</>
    }
}
